import type { ClassScheduleAddDefaults } from "@/pages/ClassesView";
import type { SessionCreationMode } from "@/lib/calendarAddSessionSignal";

export function isLegacySessionsTab(tab: string | null): boolean {
  return tab === "classes" || tab === "booking" || tab === "sessions";
}

export function sessionListHref(search = ""): string {
  const params = new URLSearchParams(search);
  if (params.get("view") === "sessions") params.delete("view");
  if (isLegacySessionsTab(params.get("tab"))) params.delete("tab");
  const query = params.toString();
  return `/sessions${query ? `?${query}` : ""}`;
}

export function isSessionListSearch(search: string): boolean {
  const params = new URLSearchParams(search);
  return params.get("view") === "sessions" || isLegacySessionsTab(params.get("tab"));
}

export function sessionAddHref(defaults?: ClassScheduleAddDefaults, mode: SessionCreationMode = "group"): string {
  const params = new URLSearchParams({ add: "true" });
  if (mode !== "group") params.set("addMode", mode);
  if (defaults?.dayOfWeek != null) params.set("dayOfWeek", String(defaults.dayOfWeek));
  if (defaults?.specificDate) params.set("specificDate", defaults.specificDate);
  if (defaults?.startTime) params.set("startTime", defaults.startTime);
  return sessionListHref(params.toString());
}

export function readSessionAddMode(params: URLSearchParams): SessionCreationMode {
  const mode = params.get("addMode");
  return mode === "availability" || mode === "private" ? mode : "group";
}

export function readSessionAddDefaults(params: URLSearchParams): ClassScheduleAddDefaults {
  const defaults: ClassScheduleAddDefaults = {};
  const day = params.get("dayOfWeek");
  if (day && /^[0-6]$/.test(day)) defaults.dayOfWeek = Number(day);
  const time = params.get("startTime");
  if (time && /^([01]\d|2[0-3]):[0-5]\d$/.test(time)) defaults.startTime = time;
  const date = params.get("specificDate");
  if (date && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    const parsed = new Date(`${date}T12:00:00`);
    if (!Number.isNaN(parsed.getTime())
      && parsed.getFullYear() === Number(date.slice(0, 4))
      && parsed.getMonth() + 1 === Number(date.slice(5, 7))
      && parsed.getDate() === Number(date.slice(8, 10))) defaults.specificDate = date;
  }
  return defaults;
}